import { Link } from "react-router-dom";
import { CalendarDays, Facebook, Instagram, Linkedin, Mail, MapPin, MessageCircle, Phone, Youtube } from "lucide-react";
import { mediaUrl, navItems } from "@/lib/api";

export const Footer = ({ settings }) => (
  <footer className="footer">
    <div className="container footer-grid">
      <div>
        <div className="brand footer-brand">
          {settings.logo ? <img src={mediaUrl(settings.logo)} alt="" className="brand-logo" /> : <span className="brand-mark">D</span>}
          <span><b>{settings.short_name || "DCEA"}</b><small>{settings.association_name}</small></span>
        </div>
        <p>{settings.footer_text}</p>
        <div className="socials">
          <a href={settings.instagram || "#instagram"} aria-label="Instagram" data-testid="footer-instagram"><Instagram size={16} /></a>
          <a href={settings.linkedin || "#linkedin"} aria-label="LinkedIn" data-testid="footer-linkedin"><Linkedin size={16} /></a>
          <a href={settings.youtube || "#youtube"} aria-label="YouTube" data-testid="footer-youtube"><Youtube size={16} /></a>
          {settings.facebook && <a href={settings.facebook} aria-label="Facebook" data-testid="footer-facebook"><Facebook size={16} /></a>}
          {settings.whatsapp && <a href={`https://wa.me/${settings.whatsapp.replace(/\D/g, "")}`} aria-label="WhatsApp" data-testid="footer-whatsapp"><MessageCircle size={16} /></a>}
        </div>
      </div>
      <div>
        <h4>Association</h4>
        {navItems.slice(0, 5).map(([l, u]) => (
          <Link key={u} to={u} data-testid={`footer-link-${u.slice(1)}`}>{l}</Link>
        ))}
      </div>
      <div>
        <h4>Resources</h4>
        {navItems.slice(5).map(([l, u]) => (
          <Link key={u} to={u} data-testid={`footer-link-${u.slice(1)}`}>{l}</Link>
        ))}
      </div>
      <div>
        <h4>Get in touch</h4>
        <span><MapPin size={15} /> {settings.address}</span>
        <span><Mail size={15} /> {settings.email}</span>
        <span><Phone size={15} /> {settings.phone}</span>
        <span><CalendarDays size={15} /> {settings.office_hours}</span>
      </div>
    </div>
    <div className="container copyright">
      <span>{settings.copyright}</span>
      {settings.developer_name && (
        <span className="dev-credit" data-testid="footer-credit">
          {settings.developer_credit || `Designed & developed by ${settings.developer_name}`}
          {settings.developer_url && <> · <a href={settings.developer_url} target="_blank" rel="noreferrer">{settings.developer_name}</a></>}
        </span>
      )}
      <Link to="/admin" data-testid="footer-admin-link">Admin sign-in</Link>
    </div>
  </footer>
);
